import YoutubeDashboardView from "src/sections/dashboards/platforms/youtube/youtube-dashboard-view";

const YoutubeCustomDashboardPage = () => <YoutubeDashboardView type="custom" />;

export default YoutubeCustomDashboardPage;
